export default "__VITE_ASSET__Du2qkEaK__"